// extracted by mini-css-extract-plugin
export default {"wrap":"ee5879f8796b"};